<template>
  <div v-if="route == 'Dashboard'">
    <div ref="trainers" class="trainers">
      <div class="content">
        <div class="profile"></div>
        <div class="main-content">
          <h1>Naši lektori</h1>
          <div class="heading-spliter"></div>
          <div class="trainers-block">
            <div class="trainer">
              <div
                class="image"
                style="background-image: url('https://www.maxman-consultants.com/data/MediaLibrary/0/112/lukas-bakos-profile.png')"
              ></div>
              <h3>Lukáš Bakoš</h3>
              <span class="text-mute"></span>
              <div class="watch-video">
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/lukas-bakos#video"
                  class="watch"
                >
                  <div class="play"></div>Pozrieť video
                </a>
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/lukas-bakos"
                  class="next"
                >
                  <div class="caret"></div>
                </a>
              </div>
            </div>

            <div class="trainer">
              <div
                class="image"
                style="background-image: url('https://www.maxman-consultants.com/data/MediaLibrary/0/109/peter-benkovic-profile.png')"
              ></div>
              <h3>Peter Benkovič</h3>
              <span class="text-mute"></span>
              <div class="watch-video">
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/peter-benkovic#video"
                  class="watch"
                >
                  <div class="play"></div>Pozrieť video
                </a>
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/peter-benkovic"
                  class="next"
                >
                  <div class="caret"></div>
                </a>
              </div>
            </div>

            <div class="trainer">
              <div
                class="image"
                style="background-image: url('https://www.maxman-consultants.com/data/MediaLibrary/0/500/sneza_web-profile.jpg')"
              ></div>
              <h3>Snežana Ďuricová</h3>
              <span class="text-mute"></span>
              <div class="watch-video">
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/snezana-duricova#video"
                  class="watch"
                >
                  <div class="play"></div>Pozrieť video
                </a>
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/snezana-duricova"
                  class="next"
                >
                  <div class="caret"></div>
                </a>
              </div>
            </div>

            <div class="trainer">
              <div
                class="image"
                style="background-image: url('https://www.maxman-consultants.com/data/MediaLibrary/0/113/lubomir-galgoci-profile.png')"
              ></div>
              <h3>Ľubomír Galgóci</h3>
              <span class="text-mute"></span>
              <div class="watch-video">
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/lubomir-galgoci#video"
                  class="watch"
                >
                  <div class="play"></div>Pozrieť video
                </a>
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/lubomir-galgoci"
                  class="next"
                >
                  <div class="caret"></div>
                </a>
              </div>
            </div>
            <div class="trainer">
              <div
                class="image"
                style="background-image: url('https://www.maxman-consultants.com/data/MediaLibrary/0/443/sasa-018-profile.jpg')"
              ></div>
              <h3>Alexandra Grófová</h3>
              <span class="text-mute"></span>
              <div class="watch-video">
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/alexandra-grofova#video"
                  class="watch"
                >
                  <div class="play"></div>Pozrieť video
                </a>
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/alexandra-grofova"
                  class="next"
                >
                  <div class="caret"></div>
                </a>
              </div>
            </div>

            <div class="trainer">
              <div
                class="image"
                style="background-image: url('https://www.maxman-consultants.com/data/MediaLibrary/0/800/dsc08313upr-profile.jpg')"
              ></div>
              <h3>Vladimír Kantor</h3>
              <span class="text-mute"></span>
              <div class="watch-video">
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/vladimir-kantor"
                  class="watch"
                >
                  <div class="play"></div>Pozrieť video
                </a>
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/vladimir-kantor"
                  class="next"
                >
                  <div class="caret"></div>
                </a>
              </div>
            </div>

            <div class="trainer">
              <div
                class="image"
                style="background-image: url('https://www.maxman-consultants.com/data/MediaLibrary/0/793/dsc08787upr-profile.jpg')"
              ></div>
              <h3>Arnold Kiss</h3>
              <span class="text-mute"></span>
              <div class="watch-video">
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/arnold-kiss#video"
                  class="watch"
                >
                  <div class="play"></div>Pozrieť video
                </a>
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/arnold-kiss"
                  class="next"
                >
                  <div class="caret"></div>
                </a>
              </div>
            </div>

            <div class="trainer">
              <div
                class="image"
                style="background-image: url('https://www.maxman-consultants.com/data/MediaLibrary/0/562/img_8158upr_peto-na-web-profile.jpg')"
              ></div>
              <h3>Peter Kukliš</h3>
              <span class="text-mute"></span>
              <div class="watch-video">
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/peter-kuklis#video"
                  class="watch"
                >
                  <div class="play"></div>Pozrieť video
                </a>
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/peter-kuklis"
                  class="next"
                >
                  <div class="caret"></div>
                </a>
              </div>
            </div>

            <div class="trainer">
              <div
                class="image"
                style="background-image: url('https://www.maxman-consultants.com/data/MediaLibrary/0/632/img_0101upr-profile.jpg')"
              ></div>
              <h3>Jarka Marčičiaková</h3>
              <span class="text-mute"></span>
              <div class="watch-video">
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/jarka"
                  class="watch"
                >
                  <div class="play"></div>Pozrieť video
                </a>
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/jarka"
                  class="next"
                >
                  <div class="caret"></div>
                </a>
              </div>
            </div>


<div class="trainer">
              <div
                class="image"
                style="background-image: url('https://www.maxman-consultants.com/data/MediaLibrary/0/468/01_michal-primarna-profile.jpg')"
              ></div>
              <h3>Michal Murárik</h3>
              <span class="text-mute"></span>
              <div class="watch-video">
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/michal-murarik#video"
                  class="watch"
                >
                  <div class="play"></div>Pozrieť video
                </a>
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/michal-murarik"
                  class="next"
                >
                  <div class="caret"></div>
                </a>
              </div>
            </div>


            <div class="trainer">
              <div
                class="image"
                style="background-image: url('https://www.maxman-consultants.com/data/MediaLibrary/0/507/orsi_web-profile.png')"
              ></div>
              <h3>Orši Véghová</h3>
              <span class="text-mute"></span>
              <div class="watch-video">
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/orsolya-veghova#video"
                  class="watch"
                >
                  <div class="play"></div>Pozrieť video
                </a>
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/orsolya-veghova"
                  class="next"
                >
                  <div class="caret"></div>
                </a>
              </div>
            </div>


            <div class="trainer">
              <div
                class="image"
                style="background-image: url('https://www.maxman-consultants.com/data/MediaLibrary/0/305/pw_1-profile.jpg')"
              ></div>
              <h3>Peter Wallin</h3>
              <span class="text-mute"></span>
              <div class="watch-video">
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/peter-wallin#video"
                  class="watch"
                >
                  <div class="play"></div>Pozrieť video
                </a>
                <a
                  href="https://www.maxman-consultants.com/sk/consultants/peter-wallin"
                  class="next"
                >
                  <div class="caret"></div>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
    <div ref="portfolio" class="portfolio">
      <div class="content">
        <div class="profile"></div>
        <div class="main-content">
          <h1>Portfólio</h1>
          <div class="heading-spliter"></div>
          <div
            class="text-mute"
          >Pre našich klientov prinášame najefektívnejšie riešenia a ponúkame rozvojové aktivity šité na mieru ich potrebám. O našich službách a produktoch, ktoré vieme zabezpečiť aj pre vašu spoločnosť, sa môžete dozvedieť viac na našich stránkach po kliknutí na Portfólio.</div>
          <a
            href="https://www.maxman-consultants.com/sk/portfolio"
            class="button"
          >Pozrieť portfólio ></a>
        </div>
      </div>
    </div>
    <div ref="news" class="news">
      <div class="content">
        <div class="profile"></div>
        <div class="main-content">
          <h1>Novinky</h1>
          <div class="heading-spliter"></div>
          <div class="articles">
            <div class="article">
              <div class="date">7.12.2018</div>
              <h2>Ako si urobiť z práce hru? | Silvester Pullman</h2>
              <span class="text-mute">
                Milí študenti, priatelia a priaznivci, čaká nás posledná ...
                <span
                  class="text-red"
                >čítať viac ></span>
              </span>
            </div>
            <div class="article">
              <div class="date">7.12.2018</div>
              <h2>Ako si urobiť z práce hru? | Silvester Pullman</h2>
              <span class="text-mute">
                Milí študenti, priatelia a priaznivci, čaká nás posledná ...
                <span
                  class="text-red"
                >čítať viac ></span>
              </span>
            </div>
            <div class="article">
              <div class="date">7.12.2018</div>
              <h2>Ako si urobiť z práce hru? | Silvester Pullman</h2>
              <span class="text-mute">
                Milí študenti, priatelia a priaznivci, čaká nás posledná ...
                <span
                  class="text-red"
                >čítať viac ></span>
              </span>
            </div>
          </div>
          <a href="https://www.maxman-consultants.com/sk/aktuality" class="button">Všetky novinky ></a>
        </div>
      </div>
    </div>
    <div ref="contact" class="newsletter">
      <div class="content">
        <div class="profile"></div>
        <div class="main-content">
          <h1>Prihlásenie sa do newslettra</h1>
          <div class="heading-spliter"></div>
          <form class="newsletter-form">
            <div
              class="col-third text-mute"
            >Zadajte prosím svoje meno a e-mail a neutečie vám už žiadna novinka</div>
            <div class="col-third">
              <div class="input">
                <input name="name" type="text" placeholder="Vaše meno" />
              </div>
            </div>
            <div class="col-third">
              <div class="input">
                <input name="email" type="email" placeholder="Email" />
              </div>
            </div>
            <div class="col-third empty"></div>
            <div class="col">
              <div class="checkbox">
                <input id="agreement" name="agreement" type="checkbox" />
                <label for="agreement" class="text-mute">Súhlasím so spracovaním osobných údajov</label>
              </div>
            </div>
            <div class="col">
              <div class="submit">
                <a href class="button">Odoslať ></a>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueScrollTo from "vue-scrollto";
import $ from "jquery";
export default {
  components: {},
  mixins: [],
  data: () => ({
    loading: false,
    model: null,
    elems: []
  }),
  created() {
    this.load();

    this.elems.push({ name: "trainers", el: this.$refs["trainers"] });
    this.elems.push({ name: "portfolio", el: this.$refs["portfolio"] });

    this.elems.push({ name: "news", el: this.$refs["news"] });
    this.elems.push({ name: "contact", el: this.$refs["contact"] });

    window.addEventListener("scroll", this.handleScroll);
    this.handleScroll();
  },
  mounted() {
    this.$nextTick(() => {
      this.scroll();
    });
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  watch: {
    $router: "scroll",
    $route: {
      handler() {
        if (this.$route.name != "Dashboard") {
          this.$api.shared.anchor = "";
          this.$api.shared.scrolledAnchor = "";
          this.scroll();
        } else {
          this.scroll(true);
        }
      },
      immediate: false
    },
    "$api.shared.anchor": {
      handler(v) {
        if (v) {
          this.scroll();
        }
      },
      immediate: true
    }
  },
  computed: {
    route() {
      return this.$route.name;
    }
  },
  methods: {
    handleScroll(event) {
      var f = false;
      for (var i in this.elems) {
        var el = this.$refs[this.elems[i].name];
        if (el) {
          var hT = $(el).offset().top,
            hH = $(el).outerHeight(),
            wH = $(window).height(),
            wS = $(window).scrollTop();
          if (wS > hT - 130) {
            f = true;
            this.$api.shared.scrolledAnchor = this.elems[i].name;
          }
        }
      }
      if (!f) {
        this.$api.shared.scrolledAnchor = "";
      }
    },
    scroll(x) {
      var v = this.$api.shared.anchor;
      if (v) {
        if (v != "nope") {
          if (v == "dash") {
            this.$nextTick(() => {
              VueScrollTo.scrollTo($("body")[0], 500);
            });
          } else {
            this.$nextTick(() => {
              VueScrollTo.scrollTo(this.$refs[v], 500, { offset: -120 });
            });
          }
        }
      } else {
        if (!x) {
          this.$nextTick(() => {
            VueScrollTo.scrollTo($("body")[0], 500);
          });
        }
      }
    },
    load() {
      this.$api.server.post("api/public/dashboard").then(r => {
        this.model = r.data;
      });
    }
  }
};
</script>
<style lang="css">
</style>



// WEBPACK FOOTER //
// src/public_app/pages/dashboard/DashBoardContent.vue